import { render, staticRenderFns } from "./ForgotPassword2.vue?vue&type=template&id=5b18e1f6"
import script from "./ForgotPassword2.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports